import { request } from './request';

export const riderApi = {
  getRiderWorkflow: (options) => request('/api/rider/workflow', options),
  getRiderOrdersGrouped: (options) => request('/api/rider/orders/grouped', options),

  getRiderOrders: (params, options = {}) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/rider/orders${qs}`, options);
  },
  lookupRiderOrderByQr: (payload) =>
    request(`/api/rider/orders/lookup?${new URLSearchParams({ q: payload }).toString()}`),
  updateRiderOrderStatus: (id, data) =>
    request(`/api/rider/orders/${id}/status`, { method: 'PATCH', body: JSON.stringify(data) }),
  batchRiderOrderStatus: (data) =>
    request('/api/rider/orders/batch-status', { method: 'POST', body: JSON.stringify(data) }),
  reorderRiderOrders: (data) =>
    request('/api/rider/orders/reorder', { method: 'POST', body: JSON.stringify(data) }),

  getRiderWallet: () => request('/api/rider/wallet'),
  riderWalletDeposit: (data) =>
    request('/api/rider/wallet/deposit', { method: 'POST', body: JSON.stringify(data) }),
  riderWalletCollect: (data) =>
    request('/api/rider/wallet/collect', { method: 'POST', body: JSON.stringify(data) }),
  getRiderWalletTransactions: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/rider/wallet/transactions${qs}`);
  },

  getRiderStats: (options) => request('/api/rider/stats', options),
  getRiderEarnings: (params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/rider/earnings${qs}`);
  },
  getMyFinance: () => request('/api/rider/finance'),
  getShopSettlement: (id) => request(`/api/shop/settlements/${id}`),

  postRiderGps: (data) => request('/api/rider/gps', { method: 'POST', body: JSON.stringify(data) }),
  riderHeartbeat: (data = {}) => request('/api/rider/heartbeat', { method: 'POST', body: JSON.stringify(data) }),
  toggleRiderOnline: (data) => request('/api/rider/toggle-online', { method: 'POST', body: JSON.stringify(data) }),
  requestRiderContact: (data) => request('/api/rider/request-contact', { method: 'POST', body: JSON.stringify(data) }),
  getRiderSyncSlot: () => request('/api/rider/sync-slot'),
};